import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'
import App from './App';
import registerServiceWorker from './registerServiceWorker';

var searchParams = new URLSearchParams(window.location.search); //?anything=123

ReactDOM.render(<App conta={searchParams.get("conta")}/>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js